<template>
  <div class="newHome">
    <home-skeleton style="margin-top: 20px;margin-bottom: 100vh" v-if="loading"></home-skeleton>
    <div v-if="!loading">
      <div class="newHome-search">
        <van-search class="header-search" v-model="value" @click="$router.push({ path: '/search-new'})">
          <template v-slot:left-icon>
            <img src="/static/v4/search_icon.svg" alt="" style="margin-top: 5px" />
          </template>
        </van-search>
        <div class="newHome-search-swiper">
          <van-swipe style="height: 36px;line-height: 36px" :autoplay="3000" vertical :show-indicators="false">
            <van-swipe-item v-for="(item, index) in search_placeholder" :key="index" @click.stop="jump(item)">
              {{ item.title }}
            </van-swipe-item>
          </van-swipe>
        </div>
      </div>
      <div class="newHome-tag" ref="homeTags">
        <van-tabs v-model="category_index" @click="changeCategory" :ellipsis="false">
          <van-tab v-for="(item, index) in categories" :key="index" :name="index" :title="item.title"></van-tab>
        </van-tabs>
        <div class="clear"></div>
      </div>
      <!--频道——推荐 -->
      <div v-if="category_index == 0" style="background: #F6F6F7;padding-bottom: 50px">
        <!--轮播图 -->
        <div style="background: #fff;padding-bottom: 12px">
          <div class="newHome-swipe">
            <van-swipe class="m-swipe" :autoplay="3000">
              <van-swipe-item v-for="(item, i) in banners" :key="i" @click='goBanner(item)'>
                <a :href="item.target_url.replace('https://byh.dr-gobroad.com', 'https://byh.dr-gobroad.com')">
                  <img :src="item.img" alt="" />
                </a>
              </van-swipe-item>
            </van-swipe>
          </div>
          <!--金刚位 内容类型：1链接，2图文-->
          <div class="newHome-pos">
            <van-swipe class="pos-swipe" indicator-color="red" :loop="false">
              <van-swipe-item v-for="(item, index) in resultTag" :key="index">
                <div class="pos-swipe-box">
                  <div class="pos-swipe-box-item" v-for="(i, ind) in item" :key="ind" @click="goPos(i)">
                    <img :src="i.logo" />
                    <span>{{ i.title }}</span>
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
          <!--消息轮播 -->
          <div class="newHome-message" v-if="msgList && msgList.length">
            <van-swipe class="mys-swipe" :autoplay="3000" vertical :show-indicators="false" style="height: 30px">
              <van-swipe-item v-for="(item, index) in msgList" :key="index">
                <div class="newHome-message-container">
                  <div class="newHome-message-container-left" @click="goMsg(item)">
                    <span>{{ item.label }}</span>
                  </div>
                  <div class="newHome-message-container-middle" @click="goMsg(item)">{{ item.title }}</div>
                  <div class="newHome-message-container-right" v-if="item.link" @click="goMsg(item)">
                    <img src="../../../static/img/icon_more.svg" />
                  </div>
                </div>
              </van-swipe-item>
            </van-swipe>
          </div>
        </div>


        <!--直播预告 看直播 -->
        <div class="newHome-live" v-if="liveList && liveList.length">
          <div class="newHome-live-title">
            <div class="newHome-live-title-left">
              <span>直播预告</span>
            </div>
            <div class="newHome-live-title-right" @click="$router.push('/live-list')">
              <span>查看更多</span>
              <img src="/static/img/naxin/icon_more.svg" />
            </div>
          </div>
          <div class="newHome-live-box">
            <swiper ref="mySwiper" :options="liveSwiperOption">
              <swiper-slide v-for="(item, index) in liveList" :key="index" class="mSwiperSlide">
                <div class="newHome-live-box-wrap" @click="goLive(item)">
                  <div class="newHome-live-box-wrap-left">
                    <img style="border-radius: 8px" :src="item.cover_img" width="112" height="71" alt="">
                  </div>
                  <div class="newHome-live-box-wrap-zl">
                    <img v-if="item.live_status == 0" src="/static/v4/icon_list_tag_live_count_down.svg" />
                    <img v-else-if="item.live_status == 1" src="/static/v4/icon_list_tag_live_process.svg" />
                  </div>
                  <div class="newHome-live-box-wrap-right">
                    <div class="newHome-live-box-wrap-right-title">
                      {{ item.title }}
                    </div>
                    <div class="newHome-live-box-wrap-right-time" v-if="item.origin_type == 4">
                      <span ref="timeRef">{{ item.start_at_format }}</span>
                      <span ref="applyRef" @click.stop="liveApply(item)"
                        v-if="item.live_status == 0 && item.isAppointment == 0">一键预约</span>
                      <span v-else-if="item.live_status == 0 && item.isAppointment == 1">已预约</span>
                      <span v-else-if="item.live_status == 1">加入</span>
                    </div>
                    <div v-else class="newHome-live-box-wrap-right-time">
                      <span>{{ item.start_at_format }}</span>
                      <span :class="[item.isAppointment == 1 ? 'active' : '']" @click.stop="liveJoin(item)">
                        {{ item.isAppointment == 1 ? '已报名' : '报名参会' }}
                      </span>
                    </div>
                  </div>
                </div>
              </swiper-slide>
            </swiper>
          </div>
        </div>


        <!--热门推荐 -->
        <div class="newHome-recommend">
          <div v-for="(item, i) in recommend" :key="item.id">
            <!--竖排-->
            <div class="newHome-recommend-section" v-if="item.layout == 1">
              <div class="newHome-recommend-title">{{ item.module_name }}</div>
              <hot-recommend :dataItem="item.module_data" :layoutType="1"></hot-recommend>
            </div>
            <!-- 横排 -->
            <div class="newHome-recommend-section" v-else-if="item.layout == 2"
              style="padding-top: 0px;background: #f7f7f8">
              <div class="live-column-section">
                <div class="column-section-title">{{ item.module_name }}</div>
                <div v-swiper:mySwiper="swiperOption" ref="liveSwipe" style="margin-top: 15px;padding-left: 12px">
                  <horizontalRecommend :data-item="item.module_data"></horizontalRecommend>
                </div>
              </div>
            </div>

            <!--新增  1+2布局 -->
            <div class="newHome-recommend-section" v-else-if="item.layout == 3">
              <div class="newHome-recommend-title">{{ item.module_name }}</div>
              <hot-recommend :dataItem="item.module_data" :layoutType="3"></hot-recommend>
            </div>
            <div class="clear"></div>
          </div>
        </div>
        <!--内容精选 -->
        <div class="newHome-content">
          <div class="newHome-content-title">
            内容精选
          </div>
          <div class="newHome-content-list">
            <van-list v-model="contentLoading" :finished="contentFinished" finished-text="已到底部" @load="onLoad">
              <contentSelection :dataItem="contentList" :posType="1" />
            </van-list>
          </div>
        </div>
      </div>
      <!--其他频道 -->
      <div v-else>
        <div class="newHome-channel">
          <!--直播 -->
          <div class="newHome-channel-section" style="margin-top: 10"
            v-if="channelclassify && channelclassify.live.count">
            <div class="newHome-channel-section-title">
              <div class="newHome-channel-section-title-left">
                <span>直播</span>
              </div>
              <div class="newHome-channel-section-title-right" @click="goMore(4)">
                <span>查看更多</span>
                <img src="/static/img/naxin/icon_more.svg" />
              </div>
            </div>
            <div class="live-list-section" v-for="(item, index) in channelclassify.live.list" :key="index"
              @click="handleChannelItem(item)">
              <div class="live-list-section-box">
                <div class="live-list-section-left">
                  <van-image class="live-list-section-left-img" fit="cover" :src="item.cover_img" />
                  <img v-if="item.type == 2" class="live-list-section-left-zl" src="/static/v4/icon_list_tag_column.svg"
                    alt="" />
                  <img v-else-if="item.live_status == 0" class="live-list-section-left-zl"
                    src="/static/v4/icon_list_tag_live_count_down.svg" alt="" />
                  <img v-else-if="item.live_status == 1" class="live-list-section-left-zl"
                    src="/static/v4/icon_list_tag_live_process.svg" alt="" />
                  <img v-else-if="item.live_status == 2" class="live-list-section-left-zl"
                    src="/static/v4/icon_list_tag_academic_end.svg" alt="" />
                  <img v-else-if="item.live_status >= 2" class="live-list-section-left-zl"
                    src="/static/v4/icon_list_tag_live_history.svg" alt="" />
                  <span v-if="item.live_status >= 2"
                    class="live-list-section-left-duration">{{ item.duration_format }}</span>
                </div>
                <div class="live-list-section-right">
                  <div class="live-list-section-right-title">{{ item.title }}</div>
                  <div class="live-list-section-right-detail chu" v-if="item.type == 2">
                    共{{ item.total_count }}期 <span style="margin-left: 8px">{{ item.view_count }}人观看</span>
                  </div>
                  <div class="live-list-section-right-detail" v-else-if="item.live_status < 2">
                    {{ item.start_at }}
                    <span class="live-list-section-right-detail-join"
                      v-if="item.live_status === 0 && item.isAppointment">已预约</span>
                    <span class="live-list-section-right-detail-join" @click.stop="liveApplyOrigin(item)"
                      v-else-if="item.live_status === 0 && !item.isAppointment">一键预约</span>
                    <span class="live-list-section-right-detail-join" v-else>加入</span>
                  </div>
                  <div class="live-list-section-right-detail" v-else-if="item.live_status >= 2">
                    <span>{{ item.view_count }}人观看</span>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <!-- 好课-->
          <div class="newHome-channel-section" v-if="channelclassify && channelclassify.course.count">
            <div class="newHome-channel-section-title">
              <div class="newHome-channel-section-title-left">
                <span>好课</span>
              </div>
              <div class="newHome-channel-section-title-right" @click="goMore(1)">
                <span>查看更多</span>
                <img src="/static/img/naxin/icon_more.svg" />
              </div>
            </div>
            <div class="subject-list-section" v-for="(item, index) in channelclassify.course.list" :key="index"
              @click="handleChannelItem(item)">
              <div class="subject-list-section-box">
                <div class="subject-list-section-left">
                  <van-image class="subject-list-section-left-img" fit="cover" :src="item.cover_img" />
                  <img v-if="item.type == 2" class="subject-list-section-left-zl"
                    src="/static/v4/icon_list_tag_column.svg" alt="" />
                </div>
                <div class="subject-list-section-right">
                  <div class="subject-list-section-right-title">{{ item.title }}</div>
                  <div class="subject-list-section-right-detail" v-if="item.type == 2">
                    共{{ item.total_count }}{{ item.source_type == 0 ? '节' : '期' }}
                    <span style="margin-left: 8px">{{ item.view_count }}人观看</span>
                  </div>
                  <div class="subject-list-section-right-detail" v-else>
                    <span>{{ item.view_count }}人观看</span>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
          <!--专栏 -->
          <div class="newHome-channel-section" v-if="channelclassify && channelclassify.medical_column.count">
            <div class="newHome-channel-section-title">
              <div class="newHome-channel-section-title-left">
                <span>专栏</span>
              </div>
              <div class="newHome-channel-section-title-right" @click="goMore(30)">
                <span>查看更多</span>
                <img src="/static/img/naxin/icon_more.svg" />
              </div>
            </div>
            <div class="column-list-section" v-for="(item, index) in channelclassify.medical_column.list" :key="index"
              @click="handleChannelItem(item)">
              <div class="column-list-section-box">
                <div class="column-list-section-left">
                  <van-image class="column-list-section-left-img" fit="cover" :src="item.cover_img" />
                  <img class="column-list-section-left-zl" src="/static/v4/icon_list_tag_column.svg" alt="" />
                </div>
                <div class="column-list-section-right">
                  <div class="column-list-section-right-title">{{ item.title }}</div>
                  <div class="column-list-section-right-detail">
                    <span v-if="item.type == 2">
                      共{{ item.total_count }}篇
                      <span style="margin-left: 8px">{{ item.view_count }}人观看</span>
                    </span>
                    <span v-else>{{ item.view_count }}人观看</span>
                    <div class="column-list-section-right-detail-join" v-if="item.is_subscribe === 0"
                      @click.stop="attention(item)">
                      <img src="/static/v4/icon_follow.svg" style="margin-right: 2px" alt="" />
                      <span>关注</span>
                    </div>
                    <div class="column-list-section-right-detail-join1" v-else>
                      <span @click.stop="attention(item)">已关注</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--学术会 -->
          <div class="newHome-channel-section" v-if="channelclassify && channelclassify.meeting_academic.count">
            <div class="newHome-channel-section-title">
              <div class="newHome-channel-section-title-left">
                <span>学术会</span>
              </div>
              <div class="newHome-channel-section-title-right" @click="goMore(31)">
                <span>查看更多</span>
                <img src="/static/img/naxin/icon_more.svg" />
              </div>
            </div>
            <div class="academic-list-section" v-for="(item, index) in channelclassify.meeting_academic.list"
              :key="index" @click="handleChannelItem(item)">
              <div class="academic-list-section-box">
                <div class="academic-list-section-box-top">
                  <img :src="item.cover_img" alt="" />
                  <div class="academic-list-section-box-zl1" v-if="item.academic_origin_type == 14">
                    <img v-if="item.meeting_status == 0" src="static/v4/icon_list_tag_live_count_down.svg" />
                    <img v-else-if="item.meeting_status == 1" src="static/v4/icon_list_tag_academic_process.svg" />
                    <img v-else-if="item.meeting_status == 2" src="static/v4/icon_list_tag_academic_end.svg" />
                  </div>
                  <div class="academic-list-section-box-zl1" v-else-if="item.academic_origin_type == 4">
                    <img v-if="item.type == 2" style="margin-left: -6px" src="/static/v4/icon_list_tag_column.svg"
                      alt="" />
                    <img v-else-if="item.live_status== 0" src="static/v4/icon_list_tag_live_count_down.svg" />
                    <img v-else-if="item.live_status== 1" src="static/v4/icon_list_tag_academic_process.svg" />
                    <img v-else-if="item.live_status >= 2" src="static/v4/icon_list_tag_academic_end.svg" />
                  </div>
                  <div class="academic-list-section-box-zl1" v-else-if="item.academic_origin_type == 13">
                    <img v-if="item.live_status== 0" src="static/v4/icon_list_tag_live_count_down.svg" />
                    <img v-else-if="item.live_status== 1" src="static/v4/icon_list_tag_academic_process.svg" />
                    <img v-else-if="item.live_status >= 2" src="static/v4/icon_list_tag_academic_end.svg" />
                  </div>
                  <div class="academic-list-section-box-btn"
                    v-if="item.academic_origin_type == 14 && item.meeting_status != 2">
                    <span v-if="item.isApply" class="meeting-list-box-img-btn-span1">已报名</span>
                    <span v-else class="meeting-list-box-img-btn-span2" @click.stop="$router.push('/login')">报名参会</span>
                  </div>
                </div>
                <div class="academic-list-section-box-title">{{ item.title }}</div>
                <div class="academic-list-section-box-time" v-if="item.academic_origin_type == 4">
                  <span v-if="item.type == 2">共{{ item.total_count }}期 <span
                      style="margin-left: 4px">{{ item.view_count }}人观看</span></span>
                  <span v-else>{{ item.start_at }}</span>
                </div>
                <div class="academic-list-section-box-time" v-if="item.academic_origin_type == 14">
                  {{ item.start_at }}-{{ item.end_at }}
                </div>
              </div>
            </div>
          </div>
          <!--指南 -->
          <div class="newHome-channel-section" v-if="channelclassify && channelclassify.download.count">
            <div class="newHome-channel-section-title">
              <div class="newHome-channel-section-title-left">
                <span>指南</span>
              </div>
              <div class="newHome-channel-section-title-right" @click="goMore(9)">
                <span>查看更多</span>
                <img src="/static/img/naxin/icon_more.svg" />
              </div>
            </div>
            <div class="download-list-section" v-for="item in channelclassify.download.list" :key="item.id">
              <div class="download-list-section-box">
                <div class="download-list-section-box-left">
                  <img v-if="item.type_text == '图文'" src="/static/two/download_article.svg" alt="" />
                  <img v-else-if="item.type_text == 'PDF'" src="/static/two/download_pdf.svg" alt="" />
                  <img v-else src="/static/third/icon_course_download_pic.svg" alt="" style="margin-left: -5px" />
                </div>
                <div class="download-list-section-box-center">
                  <div class="download-list-section-box-center-title">
                    <span class="download-list-section-title" @click="downloadItem(item)">{{ item.title }}</span>
                  </div>
                  <div class="download-list-section-box-center-desc">
                    <span class="download-list-section-box-center-desc-label">
                      {{ item.created_at }}
                      <span style="margin-left: 8px" v-if="item.type_text == '图文'">{{ item.view_count }}人阅读</span>
                      <span style="margin-left: 8px" v-else>{{ item.download_count }}人下载</span>
                      <span style="margin-left: 11px" @click="favorite(item)">
                        <img v-if="item.is_favorite" src="/static/two/download_favorite.svg" alt="" />
                        <img v-else src="/static/two/download_unfavorite.svg" alt="" />
                        <span v-if="item.is_favorite">已收藏</span>
                        <span v-else>收藏</span>
                      </span>
                    </span>
                  </div>
                </div>
                <div class="download-list-section-box-right">
                  <img @click="downloadItem(item)" v-if="item.isDownload && item.type_text != '图文'"
                    style="margin-right: 10px" src="/static/two/downloaded.svg" alt="" />
                  <img @click="downloadItem(item)" v-else-if="!item.isDownload && item.type_text != '图文'"
                    style="margin-right: 10px" src="/static/two/download.svg" alt="" />
                  <div @click="downloadItem(item)" v-else></div>
                </div>
              </div>
            </div>
          </div>
          <!--病例 -->
          <div class="newHome-channel-section" v-if="channelclassify && channelclassify.case.count">
            <div class="newHome-channel-section-title">
              <div class="newHome-channel-section-title-left">
                <span>病例</span>
              </div>
              <div class="newHome-channel-section-title-right" @click="goMore(6)">
                <span>查看更多</span>
                <img src="/static/img/naxin/icon_more.svg" />
              </div>
            </div>
            <div class="case-list-section" v-for="(item, index) in channelclassify.case.list" :key="index"
              @click="handleChannelItem(item)">
              <div class="case-list-section-box">
                <div class="case-list-section-left">
                  <van-image class="case-list-section-left-img" fit="cover" :src="item.cover_img" />
                </div>
                <div class="case-list-section-right">
                  <div class="case-list-section-right-title">{{ item.title }}</div>
                  <div class="case-list-section-right-detail" v-if="item.type == 2">
                    共{{ item.total_count }}篇
                    <span class="case-list-section-right-detail-join" v-if="item.is_subscribe === 0"
                      @click.stop="attention(item)">
                      <img src="static/v4/icon_follow.svg" style="margin-right: 2px" />
                      关注
                    </span>
                    <span v-else class="case-list-section-right-detail-join1" @click.stop="attention(item)">已关注</span>
                  </div>
                  <div class="case-list-section-right-detail" v-else>
                    <span>{{ item.created_at }}</span>
                    <span>{{ item.view_count }}人阅读</span>
                  </div>
                </div>
                <div class="clear"></div>
              </div>
              <div class="clear"></div>
            </div>
          </div>
        </div>
      </div>
      <!--底部tab -->
      <van-tabbar class="home-footer" :border="false" :fixed="true" :safe-area-inset-bottom="true" v-model="active"
        active-color="#E4263D">
        <van-tabbar-item @click="goHome()">
          <span class="home-footer-span-else">首页</span>
          <template #icon="props">
            <div class="home-footer-icon-else">
              <img src="/static/v4/icon_tab_home_1.svg" alt="" />
            </div>
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="/live-list">
          <span class="home-footer-span">直播</span>
          <template #icon="props">
            <div class="home-footer-icon">
              <img src="/static/v4/icon_tab_live_2.svg" alt="" />
            </div>
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="clinic-course">
          <span class="home-footer-span">临床好课</span>
          <template #icon="props">
            <div class="home-footer-icon">
              <img src="/static/v4/icon_tab_course_2.svg" alt="" />
            </div>
          </template>
        </van-tabbar-item>
        <van-tabbar-item to="my">
          <span class="home-footer-span">我的</span>
          <template #icon="props">
            <div class="home-footer-icon-else">
              <img src="/static/v4/icon_tab_me_2.svg" alt="" />
            </div>
          </template>
        </van-tabbar-item>
      </van-tabbar>

      <Advertisement ref="AdvertisementRef"></Advertisement>
      <van-overlay :show="applyShow">
        <div class="apply-overlay-box">
          <div class="apply-overlay-box-wrap">
            <div class="apply-overlay-box-wrap-bg">
              <img src="/static/v4/pic_tip_success_bg.svg" />
            </div>
            <div class="apply-overlay-box-wrap-close">
              <img src="/static/v4/icon_tip_close.svg" alt="" @click="closeApplyShow" />
            </div>
            <div class="apply-overlay-box-wrap-title">
              <span>预约成功提醒</span>
            </div>
            <div class="apply-overlay-box-wrap-content">
              您已成功预约本次直播，开播前将收到短信提醒。您也可在 <span>“我的”-“我的预约”</span> 中查看您的预约情况。
              扫码领取学习资料。
            </div>
            <div class="apply-overlay-box-wrap-img">
              <img src="/static/v4/code.jpg" />
            </div>
          </div>
        </div>
      </van-overlay>
      <van-dialog width="345" v-model="showEmailVisible" show-cancel-button @cancel="emailInputValue=''"
        @confirm="sendEmail">
        <template slot="title">
          <div>请填写邮箱</div>
        </template>
        <template slot="default">
          <div class="text-center" style="margin-top: 20px">请填写邮箱，资料将发送至您的邮箱里</div>
          <div class="position-input-box">
            <van-field label-class="position-title" input-align="left" v-model="emailInputValue" name="请填写邮箱"
              placeholder="请填写邮箱" ref="savePositionInput" :rules="[{ required: true }]" />
          </div>
        </template>
      </van-dialog>
      <van-dialog class="share" v-model="showShareDialog" :showConfirmButton="false">
        <div class="share-img">
          <img v-if="current_item && current_item.content" :src="current_item.content.link" style="width: 100%" alt="">
        </div>
        <div style="font-family: PingFangSC-Regular;font-size: 14px;color: #FFFFFF;text-align: center;">可长按图片保存到相册</div>
        <div class="share-cancel-btn" @click="showShareDialog = false">
          <img src="/static/img/course/icon_course_share_close.svg" alt="">
        </div>
      </van-dialog>
    </div>
  </div>
</template>

<script>
  import Advertisement from './advertisement.vue'
  import Interface from '@/util/interface'
  import homeSkeleton from '@/skeleton/homeSkeleton'
  import contentSelection from '@/components/contentSelection/index.vue'
  import hotRecommend from '@/components/hotRecommend/index.vue'
  import horizontalRecommend from '../../components/horizontalRecommend/index.vue'

  export default {
    name: 'home-new',
    components: {
      homeSkeleton,
      Advertisement,
      contentSelection,
      hotRecommend,
      horizontalRecommend
    },
    data() {
      return {
        show: true,
        loading: true,
        value: '',
        category_index: 0,
        categories: [],
        active: 0,
        liveList: [],
        banners: [],
        swiperOptionBanner: {
          width: 375,
          height: 98,
          spaceBetween: 30,
          autoplay: true,
          loop: true,
          pagination: {
            el: '.swiper-pagination',
            type: 'bullets'
          }
        },
        resultTag: [],
        msgList: [],
        liveSwiperOption: {
          width: 320,
          height: 249,
          spaceBetween: 10,
          loop: true,
          loopAdditionalSlides: 1
        },
        swiperOption: {
          width: 180,
          height: 249,
          spaceBetween: 8
        },
        recommend: [],
        search_placeholder: [],
        channelclassify: null,
        applyShow: false,
        contentLoading: false,
        contentFinished: false,
        contentPage: 0, // 内容精选分页数
        contentList: [],
        liveItem: null, // 直播预告某个item信心
        showShareDialog: false,
        current_item: {},
        showEmailVisible: false,
        emailInputValue: "",
        exposureArr: []
      }
    },
    created() {
      this.fetch('banner')
      this.fetch('search_text')
      this.fetch('live')
      Interface.initChannel('search')
      window.addEventListener('scroll', this.onScroll)
      let source_type = Interface.getUrl(window.location.href)
      if (source_type) {
        Interface.mFootPrint(0, 36, 0, 1, source_type, '首页')
      } else {
        Interface.mFootPrint(0, 36, 0, 1, 0, '首页')
      }
    },
    activated() {
      if (this.category_index) {
        this.category_index = 0
        this.changeCategory()
      }
    },
    mounted() {
      // this.$refs.AdvertisementRef.fetch('homepage')
    },
    destroyed() {
      this.exposureArr = []
    },
    methods: {
      fetch(scene) {
        if (scene === 'banner') {
          Interface.getData('get', Interface.home).then(res => {
            this.banners = res.data.banners
            this.recommend = res.data.recommend
            let tempArr = [...res.data.position_type_1]
            for (let i = 0; i < tempArr.length; i += 10) {
              this.resultTag.push(tempArr.slice(i, i + 10))
            }
            this.msgList = res.data.messages
            this.fetch('tags')
            setTimeout(() => {
              this.loading = false
            }, 300)
            Interface.getShareInfo(this, '', '', '一站式垂直医生社区，学术会议、指南文献、医学资讯、实用工具。',
              36, '', Interface.host + '/#/?source_type=1')
          })
        } else if (scene === 'live') {
          Interface.getData('get', Interface.v4.live).then(res => {
            this.liveList = res.data
            if (res.data.length === 1) {
              this.liveSwiperOption.loop = false
            }
          })
        } else if (scene === 'tags') {
          let params = {
            origin_type: 0
          }
          Interface.getData('get', Interface.v4.channel, params).then(res => {
            if (res.data.list) {
              this.categories.push({
                id: 0,
                title: '推荐'
              })
              this.categories.push(...res.data.list)
              let search_channel = sessionStorage.getItem('search_channel')
              if (this.$route.query.search_channel > 0) {
                this.category_index = parseInt(this.$route.query.search_channel)
                this.changeCategory()
              } else if (search_channel != null) {
                this.category_index = parseInt(search_channel)
                this.changeCategory()
              }
            }
          })
        } else if (scene === 'channel_item') {
          if (this.category_index == 0) {
            return
          }
          Interface.getData('get', Interface.v4.channel_item + '/' + this.channel.id + '/home').then(res => {
            if (res.code == 0) {
              this.channelclassify = res.data
            }
          })
        } else if (scene === 'search_text') {
          // 获取底纹词
          Interface.getData('get', Interface.v4.search_list, {
            type: 2
          }).then(res => {
            if (res.code == 0) {
              this.search_placeholder = res.data.hot_words
            }
          })
        }
      },
      // 频道切换
      changeCategory() {
        //
        sessionStorage.setItem('search_channel', this.category_index)
        this.$router.push({
          name: 'home-new',
          query: {
            search_channel: this.category_index
          }
        })
        this.channel = this.categories[this.category_index]
        document.title = '博医荟-' + this.channel.title
        if (this.channel.id) {
          Interface.mFootPrint(this.channel.id, 32, 0, 1, 0, this.channel.title)
        }
        this.fetch('channel_item')
      },
      goHome() {
        this.category_index = 0
        this.changeCategory()
      },
      async downloadItem(item) {
        console.log('item====', item)
        if (item.type == 1) {
          var u = navigator.userAgent
          var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
          if (isiOS) {
            if (item.filesize < 20480) {
              await this.getDetailDownload(item.id)
              item.download_count += 1
              window.location.href = item.link
              return
            }
          }
          this.showEmailVisible = true
          this.current_item = item
        } else if (item.type == 3) {
          this.$router.push({
            name: 'download-detail',
            params: {
              id: item.id
            }
          })
        } else {
          this.showShareDialog = true
          this.current_item = item
        }
      },
      async getDetailDownload(id) {
        await Interface.getData('get', Interface.download.download + '/' + id).then(res => {
          return res
        })
      },
      sendEmail() {
        let params = {
          id: this.current_item.id,
          email: this.emailInputValue
        }
        localStorage.setItem("email", params.email)
        Interface.getData('post', Interface.download.email, params).then((res) => {
          if (res.code == 0) {
            this.$dialog.alert({
              title: '提示',
              message: '已经记录您的邮箱 , 稍后将发送文件到您的邮箱中',
              confirmButtonText: "确认"
            })
          }
        })
      },
      go_detail(item) {
        if (item.origin_type == 1) {
          Interface.goCourse(this, {
            id: item.origin_id,
            type: item.type
          })
        } else if (item.origin_type == 2) {
          Interface.goArticle(this, {
            id: item.origin_id,
            type: item.type
          })
        } else if (item.origin_type == 3) {
          Interface.goVideo(this, {
            id: item.origin_id,
            type: item.type
          })
        } else if (item.origin_type == 4) {
          Interface.goLiveDetail(this, {
            id: item.origin_id,
            type: item.type,
            isAppointment: item.isAppointment,
            live_status: item.live_status
          })
        } else if (item.origin_type == 13) {
          Interface.goTopic(this, {
            id: item.origin_id,
            type: item.type
          })
        } else if (item.origin_type == 14) {
          Interface.goMeeting(this, {
            is_saas: item.is_saas,
            uuid: item.uuid,
            type: item.type
          })
        } else if (item.origin_type == 30) {
          Interface.goMedicalColumn(this, {
            id: item.origin_id,
            type: item.type
          })
        }
      },
      go_live_detail(item) {
        if (item.type === 2) {
          this.$router.push({
            name: 'live-column',
            params: {
              id: item.origin_id
            }
          })
        } else if (item.live_status === 6) {
          this.$router.push({
            name: 'live-detail-home',
            params: {
              id: item.origin_id
            }
          })
        } else {
          if (item.live_status === 0) {
            this.$router.push({
              name: 'live-detail',
              params: {
                id: item.origin_id
              }
            })
          } else {
            this.$router.push({
              name: 'live-detail-home',
              params: {
                id: item.origin_id
              }
            })
          }
        }
      },
      // 内容精选分页加载
      onLoad() {
        this.contentPage++
        let params = {
          content_type: '',
          page: this.contentPage,
          pageSize: 10
        }
        Interface.getData('get', Interface.v4.content_select, params).then(res => {
          if (res.code == 0) {
            if (res.data.list && res.data.list.length) {
              this.contentList.push(...res.data.list)
            }
            this.contentLoading = false
            if (this.contentPage >= res.data.total_page) {
              this.contentFinished = true
            }
          }
        })
      },
      // 刷新内容精选
      freshList() {
        this.$nextTick(() => {
          this.contentPage = 0
          this.onLoad()
          this.$forceUpdate()
        })
      },
      // 跳转到搜索页面
      jump(item) {
        let search = JSON.stringify(item)
        this.$router.push({
          path: '/search-new',
          query: {
            search: search
          }
        })
      },
      // 金刚位跳转
      goPos(item) {
        Interface.mFootPrint(item.id, 34, 0, 1, 0, item.title)
        if (item.content_type == 1) {
          // 1 是链接
          window.location.href = item.link
          // console.log(item.link)
        } else if (item.content_type == 2) {
          // 2是图文
          this.$router.push({
            name: 'image-text',
            params: {
              id: item.id
            }
          })
        }
      },
      // 消息跳转
      goMsg(item) {
        if (item.link) {
          location.href = item.link
          Interface.mFootPrint(item.id, 35, 0, 1, 0, item.title)
        }
      },
      // 跳转到频道更多页面
      goMore(type) {
        this.$router.push({
          name: 'channel-more',
          params: {
            id: this.channel.id,
            origin_type: type
          }
        })
      },
      // 关注/未关注
      attention(item) {
        // is_subscribe 0 未关注  1 已关注
        if (item.is_subscribe == 1) {
          // 取消关注
          this.$dialog
            .confirm({
              title: '提醒',
              message: '确定取消关注吗？',
              confirmButtonText: '确定',
              className: 'dly-dialog'
            })
            .then(() => {
              Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
                if (res.code == 0) {
                  this.$toast.success('取消关注成功')
                  this.changeCategory()
                }
              })
            })
            .catch(() => {
              console.log(1)
            })
        } else {
          // 关注
          Interface.getData('get', Interface.v4.attation + '/' + item.origin_id).then(res => {
            if (res.code == 0) {
              this.$toast.success('关注成功')
              this.changeCategory()
            }
          })
        }
      },
      goLive(item) {
        if (item.origin_type == 4) {
          // 直播
          Interface.goLiveDetail(this, {
            id: item.id,
            type: 1,
            live_status: item.live_status,
            isAppointment: item.isAppointment
          })
          Interface.mFootPrint(item.id, 4, 0, 1, 0, item.title)
        } else if (item.origin_type == 14) {
          // 会议
          Interface.goMeeting(this, {
            uuid: item.uuid,
            type: item.type,
            is_saas: item.is_saas
          })
          Interface.mFootPrint(item.uuid, 14, 0, 1, 0, item.title)
        } else if (item.origin_type == 13) {
          this.$router.push({
            name: 'topic-detail',
            params: {
              id: item.origin_id
            }
          })
          Interface.mFootPrint(item.origin_id, 13, 0, 1, 0, item.title)
        }
      },
      // 直播-一键预约
      liveApply(item) {
        this.liveItem = item
        if (!item.isAppointment) {
          // 判断是否认证 0 未认证   1已认证
          let user = localStorage.getItem('user')

          let is_complete = JSON.parse(user).is_complete

          if (is_complete == 1) {
            Interface.getData('get', Interface.v4.apply + '/' + item.id, {
              page_type: 1
            }).then(res => {
              if (res.code == 0) {
                this.applyShow = true
                // this.fetch('live')
              }
            })
          } else {
            // 去认证
            this.$dialog
              .confirm({
                title: '需要登录',
                message: '为了方便学习课程,需要您登录认证',
                confirmButtonText: '去认证'
              })
              .then(() => {
                sessionStorage.setItem('back-url', this.$route.path)
                this.$router.push({
                  name: 'login'
                })
              })
              .catch(() => {
                // on cancel
              })
          }
        } else {
          Interface.goLiveDetail(this, item)
        }
      },
      // 直播-一键预约
      liveApplyOrigin(item) {
        this.liveItem = {
          id: item.origin_id,
          live_status: item.live_status,
          isAppointment: item.isAppointment
        }
        if (!item.isAppointment) {
          // 判断是否认证 0 未认证   1已认证
          let user = localStorage.getItem('user')

          let is_complete = JSON.parse(user).is_complete

          if (is_complete == 1) {
            Interface.getData('get', Interface.v4.apply + '/' + item.origin_id).then(res => {
              if (res.code == 0) {
                this.applyShow = true
              }
            })
          } else {
            // 去认证
            this.$dialog
              .confirm({
                title: '需要登录',
                message: '为了方便学习课程,需要您登录认证',
                confirmButtonText: '去认证'
              })
              .then(() => {
                sessionStorage.setItem('back-url', this.$route.path)
                this.$router.push({
                  name: 'login'
                })
              })
              .catch(() => {
                // on cancel
              })
          }
        } else {
          Interface.goLiveDetail(this, {
            id: item.origin_id,
            type: item.type,
            live_status: item.live_status
          })
        }
      },
      // 关闭预约弹框
      closeApplyShow() {
        this.applyShow = true
        // 同时跳转到直播间
        this.$router.push({
          name: 'live-detail-home',
          params: {
            id: this.liveItem.id
          }
        })
      },
      // 直播-报名参会
      liveJoin(item) {
        if (item.origin_type == 14) {
          // 会议
          Interface.goMeeting(this, {
            uuid: item.uuid,
            type: item.type,
            is_saas: item.is_saas
          })
        } else {
          this.liveApplyOrigin(item)
        }
      },
      // 频道item跳转
      handleChannelItem(item) {
        switch (item.origin_type) {
          case 1: // 好课
            if (item.source_type == 0) {
              // 课程专栏
              this.$router.push({
                name: 'course-column',
                params: {
                  id: item.origin_id
                }
              })
            } else if (item.source_type == 4) {
              // 直播专栏
              this.$router.push({
                name: 'video-column',
                params: {
                  id: item.source_id
                }
              })
            }
            break
          case 4: // 直播
            Interface.goLiveDetail(this, {
              id: item.origin_id,
              type: item.type,
              live_status: item.live_status,
              isAppointment: item.isAppointment
            })
            break
          case 6: // 病例
            const pathUrl = item.type === 1 ? 'article-detail' : 'case-column'
            this.$router.push({
              name: pathUrl,
              params: {
                id: item.origin_id
              }
            })
            break
          case 9: // 指南
            // this.$router.push({ name: 'download-list' })
            break
          case 30: // 专栏
            // this.$router.push({ name: 'topic-detail', params: { id: item.origin_id } })
            this.$router.push({
              name: 'medical-column-list',
              params: {
                id: item.origin_id
              }
            })
            break
          case 31: // 学术会
            if (item.academic_origin_type == 4) {
              // 直播
              Interface.goLiveDetail(this, {
                id: item.content_id,
                type: item.type,
                live_status: item.live_status,
                isAppointment: item.isAppointment,
              })
            } else if (item.academic_origin_type == 14) {
              // 会议
              Interface.goMeeting(this, {
                is_saas: item.is_saas,
                uuid: item.uuid,
                type: item.type
              })
            } else if (item.academic_origin_type == 13) {
              this.$router.push({
                name: 'topic-detail',
                params: {
                  id: item.content_id
                }
              })
            }
            break
        }
      },
      goBanner(item) {
        Interface.mFootPrint(item.id, 33, 0, 1, 0, item.title)
      },
      favorite(item) {
        Interface.getData('get', Interface.download.favorite + item.origin_id).then(res => {
          if (res.code == 0) {
            item.is_favorite = !item.is_favorite
          }
        })
      },
      onScroll() {
        let recommend = document.querySelector('.newHome-recommend')
        let tempArr = []
        // console.log('recommend===', recommend,recommend.children.length)
        if (!recommend) {
          return
        }
        for (let i = 0; i < recommend.children.length; i++) {
          if (Math.abs(recommend.children[i].getBoundingClientRect().top) < 5) {
            let arr = this.recommend[i].module_data
            arr.forEach((item) => {
              let obj = {
                type: item.origin_type,
                origin_id: item.origin_id,
                title: item.title,
                page_type: 1
              }
              tempArr.push(obj)
            })
          }
        }
        if (tempArr && tempArr.length) {
          let obj = JSON.stringify(tempArr[0])
          if (!JSON.stringify(this.exposureArr).includes(obj)) {
            Interface.exposureFootPrint(JSON.stringify(tempArr))
            this.exposureArr.push(...tempArr)
          }
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  @import './index_new.scss';
</style>



// WEBPACK FOOTER //
// src/views/home/index_new.vue